import { Component, Input, OnInit } from '@angular/core';

interface Filters {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {

  @Input () productName: string;

  filterOptions: Filters[] = [
    { value: 'minorPrice', viewValue: 'Menor precio' },
    { value: 'mayorPrice', viewValue: 'Mayor precio' },
    { value: 'minorPoints', viewValue: 'Menor cantidad puntos' },
    { value: 'mayorPoints', viewValue: 'Mayor cantidad puntos' }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
